export const HasProjectMixin = target =>
  class extends target {
    get project() {
      return super.project || this.firstStore?.crudManager;
    }

    set project(project) {
      super.project = project;
    }
  };
